import { Users, Star, Clock, Shield, CheckCircle, Zap } from 'lucide-react';
import statsBackground from '@/assets/stats-trust-background.jpg';
const stats = [{
  icon: Users,
  number: '1000+',
  label: 'Satisfied Customers',
  description: 'Across Gold Coast'
}, {
  icon: Star,
  number: '4.9/5',
  label: 'Average Rating',
  description: 'Google Reviews'
}, {
  icon: Clock,
  number: '30 min',
  label: 'Response Time',
  description: 'Quick Reply'
}, {
  icon: Shield,
  number: 'Parts',
  label: 'Warranty',
  description: 'On All Work'
}];
export const StatsSection = () => {
  return <section className="py-12 lg:py-24 relative overflow-hidden bg-gradient-to-br from-primary/5 via-background to-muted/10 mobile-section-spacing">
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 hero-pattern opacity-30"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="section-header">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-primary to-primary-hover rounded-2xl mb-8 shadow-[var(--shadow-glow)]">
            <Star className="w-10 h-10 text-white fill-white" />
          </div>
          <h2 className="section-title">
            Trusted by Gold Coast Residents
          </h2>
          <p className="section-subtitle">
            Our commitment to quality service and customer satisfaction speaks for itself through real results and genuine testimonials
          </p>
          <div className="section-divider" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mobile-grid-fix">
          {stats.map((stat, index) => <div key={index} className="stats-card group">
              <div className="section-icon mx-auto mb-8 bg-gradient-to-br from-primary to-primary-hover group-hover:scale-110 transition-all duration-300 flex items-center justify-center">
                <stat.icon className="w-10 h-10 text-white" />
              </div>
              
              <div className="space-y-3 text-center">
                <div className="text-5xl font-bold text-foreground mb-4 group-hover:text-primary transition-colors duration-300">
                  {stat.number}
                </div>
                
                <div className="text-xl font-bold text-foreground mb-2 leading-tight">
                  {stat.label}
                </div>
                
                <div className="text-muted-foreground font-medium leading-relaxed">
                  {stat.description}
                </div>
              </div>
              
              {/* Premium hover effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl" />
            </div>)}
        </div>
      </div>
    </section>;
};